import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDrawer } from 'src/hooks/useDrawer';
import { isPwa } from 'src/constants';
import { useApiContext } from 'react-easyrocket';
import { SimpleClose } from 'src/components/svg/Closes';
import { useSettings } from 'src/modules/settings';
import { DAY } from 'src/constants/timeMeasures';
import { LogoApp } from 'src/config/components/LogoApp';

export const PwaPopup: FC = () => {
  const { t } = useTranslation();
  const { closeDrawer } = useDrawer();
  const {
    pwa: { promptPwaPopup, isPwaPopupVisible, showPwaPopup, hidePwaPopup }
  } = useSettings();
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (isPwa) return;
    const lastClose = localStorage.getItem('timeHideMobilePopup');
    if (!lastClose || Number(lastClose) > Date.now() + DAY) {
      showPwaPopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const handleInstallClick = () => {
    closeDrawer();
    promptPwaPopup();
    hidePwaPopup();
  };

  const handleCloseClick = (e: MouseEvent) => {
    e.stopPropagation();
    localStorage.setItem('timeHideMobilePopup', `${Date.now()}`);
    hidePwaPopup();
  };

  if (!isPwaPopupVisible) return null;

  return (
    <div
      className="top-0 bg-gradient-to-t from-mobap_bg_from to-mobap_bg_to px-2.5 py-[5px] text-b_secondary_text cursor-pointer items-center left-0 bottom-0 right-0 w-full h-auto z-[1000] flex gap-x-[10px]"
      onClick={handleInstallClick}>
      <div className="rounded-[10px]">
        <LogoApp className="w-[40px] h-[40px]" />
      </div>

      <div className="text-[14px] font-bold flex-1">{t('general.pwaInstall')}</div>

      <SimpleClose
        className="ml-auto"
        fill="var(--mobap_close)"
        onShow={(e) => handleCloseClick(e)}
      />
    </div>
  );
};
